import { QueryParamConfig } from 'use-query-params'

export const TrueFalseBooleanParam = {
  encode: (bool: boolean | undefined) => (bool ? 'true' : undefined),
  decode: (value: string | (string | null)[] | null | undefined) => {
    const stringValue = Array.isArray(value) ? value[0] : value

    return stringValue === 'true' ? true : undefined
  }
} as QueryParamConfig<boolean | undefined, string | undefined>
